import { urls } from "../../urls";
import type { NavItem } from "./navConfig";

export const isNavItemActive = (
  item: NavItem,
  pathname: string,
  search: string,
  siblings: readonly NavItem[] = [],
): boolean => {
  if (item.query) {
    return pathname === item.path && search === `?${item.query}`;
  }
  if (pathname === item.path) {
    return !siblings.some((sibling) => sibling.query && sibling.path === pathname && search === `?${sibling.query}`);
  }
  return item.path !== urls.app.home && pathname.startsWith(`${item.path}/`);
};
